import { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate, Link } from "react-router-dom";
import { LOCATIONS } from "../../data/locations";
import "./Home.css";
import DreamGarden from "../DreamGarden/DreamGarden";
import Services    from "../Services/Services";
import StatusBar   from "../StatusBar/StatusBar";
import SEO from "../SEO/SEO";

import GarvanaHome2 from "../../Comon/Images/GarvanaHome2.jpg";
import GarvanaHome3 from "../../Comon/Images/GarvanaHome3.jpg";
import GarvanaHome4 from "../../Comon/Images/GarvanaHome4.jpg";
import GarvanaHome6 from "../../Comon/Images/GarvanaHome6.jpg";
import GarvanaHome7 from "../../Comon/Images/GarvanaHome7.jpg";
import Garden5      from "../../Comon/Images/Garden5.jpg";
import Garden24     from "../../Comon/Images/garvana24.jpeg";
import AboutUs from "../AboutUs/AboutUs";

const BASE_SLIDES = [
  { image: GarvanaHome4, label: "Award-Winning Expertise",    title: "The Art of Landscape Architecture",     subtitle: "Where Nature Meets Luxury Design",              color: "#b8942e", overlay: "rgba(8,15,8,0.75)"  },
  { image: Garden24,     label: "Premium Residential",        title: "Your Garden, Elevated to Perfection",   subtitle: "Custom Designs for Discerning Homeowners",      color: "#4caf50", overlay: "rgba(0,40,10,0.7)"   },
  { image: GarvanaHome3, label: "Transform Your Space",       title: "From Vision to Living Masterpiece",     subtitle: "Expert Landscaping Across Delhi NCR",           color: "#5eb8c8", overlay: "rgba(0,20,30,0.7)"   },
  { image: GarvanaHome2, label: "Creative Outdoor Solutions", title: "Crafting Timeless Outdoor Sanctuaries", subtitle: "Bespoke Designs for Every Space",               color: "#c9813a", overlay: "rgba(40,20,0,0.7)"   },
  { image: GarvanaHome6, label: "Sustainable Luxury",         title: "Beautiful Spaces. Sustainable Futures.", subtitle: "Eco-Friendly Designs Without Compromise",      color: "#7ab03a", overlay: "rgba(10,40,0,0.7)"   },
  { image: GarvanaHome7, label: "Elegant Garden Design",      title: "Elegance Rooted in Nature",             subtitle: "10+ Years of Horticultural Excellence",         color: "#c06880", overlay: "rgba(40,0,20,0.7)"   },
  //{ image: Garden5,      label: "Full-Service Landscaping",   title: "Every Detail, Perfectly Considered",    subtitle: "End-to-End Garden Management",                  color: "#4a9ec8", overlay: "rgba(0,20,40,0.7)"   },
];

/*
  Infinite loop trick — clone first slide at end, clone last slide at start.
  Rendered order:  [last_clone, 0, 1, 2, 3, 4, 5, 6, first_clone]
  Real indices:     0            1  2  3  4  5  6  7   8
  Visual index starts at 1 (real slide 0).
*/
const SLIDES = [
  BASE_SLIDES[BASE_SLIDES.length - 1], // clone of last
  ...BASE_SLIDES,
  BASE_SLIDES[0],                       // clone of first
];
const TOTAL     = BASE_SLIDES.length;
const FIRST_IDX = 1;          // real index of first real slide
const LAST_IDX  = TOTAL;      // real index of last real slide

/* ── Split text into animated letter spans ── */
const SplitText = ({ text, className, delay = 0 }) => (
  <span className={className}>
    {text.split("").map((char, i) => (
      <span key={i} className="hero-letter" style={{ animationDelay: `${delay + i * 0.038}s` }}>
        {char === " " ? "\u00A0" : char}
      </span>
    ))}
  </span>
);

export default function Home() {
  /* realIdx: index inside SLIDES array (includes clones) */
  const [realIdx,      setRealIdx]      = useState(FIRST_IDX);
  const [animating,    setAnimating]    = useState(true);  // enable CSS transition
  const [animKey,      setAnimKey]      = useState(0);
  const [labelVisible, setLabelVisible] = useState(true);
  const timerRef  = useRef(null);
  const navigate  = useNavigate();

  /* visual dot index (0-based, no clones) */
  const dotIdx = realIdx === 0 ? TOTAL - 1
               : realIdx === TOTAL + 1 ? 0
               : realIdx - 1;

  /* current slide data (clamp to real slides for clones) */
  const slideData = SLIDES[realIdx] ?? BASE_SLIDES[0];

  /* advance to next real slide */
  const advance = useCallback(() => {
    setAnimating(true);
    setRealIdx((i) => i + 1);
    setAnimKey((k) => k + 1);
    setLabelVisible(false);
    setTimeout(() => setLabelVisible(true), 80);
  }, []);

  /* auto-advance */
  useEffect(() => {
    timerRef.current = setInterval(advance, 5500);
    return () => clearInterval(timerRef.current);
  }, [advance]);

  /*
    After transitioning to a clone (index 0 or TOTAL+1),
    silently teleport to the real counterpart with transition disabled.
  */
  const handleTransitionEnd = useCallback(() => {
    if (realIdx === TOTAL + 1) {
      setAnimating(false);
      setRealIdx(FIRST_IDX);
    } else if (realIdx === 0) {
      setAnimating(false);
      setRealIdx(LAST_IDX);
    }
  }, [realIdx]);

  /* dot click — go to a specific base slide */
  const goTo = (baseIdx) => {
    clearInterval(timerRef.current);
    const target = baseIdx + 1; // +1 because of leading clone
    if (target === realIdx) return;
    setAnimating(true);
    setRealIdx(target);
    setAnimKey((k) => k + 1);
    setLabelVisible(false);
    setTimeout(() => setLabelVisible(true), 80);
    timerRef.current = setInterval(advance, 5500);
  };

  return (
    <>
      <SEO path="/" />
      {/* ── HERO ── */}
      <section className="hero">
        {/* Slider track */}
        <div
          className="hero__slider"
          style={{
            transform:  `translateX(-${realIdx * 100}%)`,
            transition: animating ? "transform 2.0s cubic-bezier(0.77,0,0.175,1)" : "none",
          }}
          onTransitionEnd={handleTransitionEnd}
        >
          {SLIDES.map((s, i) => (
            <div key={i} className="hero__slide">
              <img
                src={s.image}
                alt=""
                className={`hero__img ${i === realIdx ? "hero__img--active" : ""}`}
              />
              <div
                className="hero__overlay"
                style={{ background: `linear-gradient(150deg, ${s.overlay} 0%, rgba(0,0,0,0.18) 60%, transparent 100%)` }}
              />
            </div>
          ))}
        </div>

        {/* Floating particles */}
        <div className="hero-particles" aria-hidden="true">
          {[...Array(8)].map((_, i) => (
            <span key={i} className={`hero-particle hero-particle--${i + 1}`} style={{ "--p-color": slideData.color }} />
          ))}
        </div>

        {/* Content */}
        <div className="hero__content" style={{ "--accent-color": slideData.color }} key={animKey}>
          <span className={`hero__label ${labelVisible ? "hero__label--visible" : ""}`}>
            {slideData.label}
          </span>

          <h1 className="hero__title">
            <SplitText text={slideData.title} className="hero-title__text" delay={0.18} />
          </h1>

          <p className="hero__subtitle hero__subtitle--anim">
            {slideData.subtitle}
          </p>

          <div className="hero__actions hero__actions--anim">
            <button className="hero__btn hero__btn--primary" onClick={() => navigate("/services")}>
              Our Services
            </button>
            <button className="hero__btn hero__btn--outline" onClick={() => navigate("/contact")}>
              Get Quote
            </button>
          </div>
        </div>

        {/* Progress bar */}
        <div className="hero__progress" key={`prog-${animKey}`}>
          <div className="hero__progress-bar" style={{ "--accent-color": slideData.color }} />
        </div>

        {/* Dot indicators
        <div className="hero__indicators">
          {BASE_SLIDES.map((_, i) => (
            <button
              key={i}
              className={`hero__dot ${i === dotIdx ? "hero__dot--active" : ""}`}
              style={i === dotIdx ? { "--accent-color": slideData.color } : {}}
              onClick={() => goTo(i)}
              aria-label={`Slide ${i + 1}`}
            />
          ))}
        </div> */}

        {/* Scroll hint */}
        <div className="hero__scroll-hint">
          <span className="hero__scroll-line" />
          <span className="hero__scroll-text">Scroll</span>
        </div>

      </section>

      <StatusBar />

      {/* ── SEO INTRO — crawlable keyword content + internal links to city pages ── */}
      <section className="home-seo">
        <div className="home-seo__inner">
          <span className="section-label">Luxury Landscape Design · Delhi NCR &amp; Pan India</span>
          <h2 className="section-title">
            India's Premium Landscape Design &amp; Garden Management Company
          </h2>
          <span className="gold-divider" />
          <p className="home-seo__p">
            Garvaana Enterprise is a luxury landscape design and garden management company serving
            Delhi NCR and Pan India. As one of the <strong>best landscape designers in Delhi NCR</strong>,
            we craft bespoke villa gardens, terrace &amp; rooftop gardens, farmhouse landscapes,
            vertical green walls, swimming-pool landscaping, water features and corporate green
            spaces — designed, built and maintained to the highest standard.
          </p>
          <p className="home-seo__p">
            From our studio in Noida, our landscape architects and horticulturists deliver
            end-to-end <strong>landscape design services</strong> — 3D visualisation, installation,
            premium planting from our 500+ variety nursery, smart irrigation, garden lighting, and
            year-round maintenance contracts for homes, societies, hotels and developers.
          </p>

          <h3 className="home-seo__h3">Landscape Design Services by City</h3>
          <div className="home-seo__cities">
            {LOCATIONS.map((loc) => (
              <Link key={loc.slug} to={`/${loc.slug}`} className="home-seo__city">
                Landscape Design in {loc.city}
              </Link>
            ))}
          </div>

          <div className="home-seo__actions">
            <button className="btn-luxury" onClick={() => navigate("/services")}>Explore Services</button>
            <button className="btn-luxury-outline" onClick={() => navigate("/contact")}>Free Consultation</button>
          </div>
        </div>
      </section>

      <Services />
      <AboutUs/>
      <DreamGarden />
    </>
  );
}